<div class="entity-component-response-container" *ngIf="responseData">

  <!-- Draft ID and Commit ID - Section at the top of response message -->
  <div class="draft-commit-section" *ngIf="getDraftId() || getStepId()">
    <div class="draft-id-container" *ngIf="getDraftId()">
    <div class="draft-id-container-content"
    [nz-tooltip]="getDraftId()"
    [nzTooltipPlacement]="'top'"
    [nzTooltipTitle]="'Draft ID'">
      <i class="fa-solid fa-code-branch draft-icon"></i>
      <span class="draft-id-value">{{ getDraftId() }}</span>
    </div>
    </div>
    <div class="commit-id-container" *ngIf="getStepId()"
    [nz-tooltip]="getStepId()"
    [nzTooltipPlacement]="'top'"
    [nzTooltipTitle]="'Commit ID'">
      <span class="commit-id-label">commit</span>
      <span class="commit-id-value">{{ getStepId() }}</span>
    </div>
  </div>

  <!-- Compilation Loading State -->
  <div class="loading-state" *ngIf="isCompilingLoading && !getError()">
    <nz-spin nzSize="large" [nzTip]="isRetrying ? 'Retrying compilation...' : 'Component compiling...'">
    </nz-spin>
  </div>

  <!-- Bundle Loading State -->
  <div class="loading-state" *ngIf="isBundleLoading && !isCompilingLoading && !getError()">
    <nz-spin nzSize="large" nzTip="Preparing component...">
    </nz-spin>
  </div>

  <!-- Error State -->
  <rappider-alert *ngIf="getError()"
                  [type]="AlertTypes.Error"
                  [title]="{
                    content: 'Component Generation Failed',
                    type: HeadingType.H4
                  }"
                  [description]="{
                    text: getError() || undefined
                  }"
                  [showIcon]="true"
                  [closeable]="false"
                  [colorSettings]="{
                    backgroundColor: 'var(--danger-background-color, #fff2f0)'
                  }"
                  [borderSettings]="{
                    border: '1px solid var(--danger-color)',
                    borderRadius: 'var(--border-radius-2x)'
                  }"
                  [marginSettings]="{
                    bottom: 'var(--margin-4x)'
                  }">
  </rappider-alert>

  <!-- Info State (Retry Message) -->
  <rappider-alert *ngIf="getInfoMessage() && !getError()"
                  [type]="AlertTypes.Info"
                  [title]="{
                    content: 'Compilation Failed. We\'re now analyzing the error to identify the cause and implement a fix.',
                    type: HeadingType.H4
                  }"
                  [description]="{
                    text: getInfoMessage() || undefined
                  }"
                  [showIcon]="true"
                  [closeable]="false"
                  [colorSettings]="{
                    backgroundColor: 'var(--info-background-color, #f0f9ff)'
                  }"
                  [borderSettings]="{
                    border: '1px solid var(--info-color)',
                    borderRadius: 'var(--border-radius-2x)'
                  }"
                  [marginSettings]="{
                    bottom: 'var(--margin-4x)'
                  }">
  </rappider-alert>

  <!-- Component Render -->
  <div class="component-render" *ngIf="!isCompilingLoading && !isBundleLoading && getBundleContent() && !getError() && !isRetrying">
    <!-- Component Renderer -->
    <rappider-compiled-component-renderer
      [componentType]="'flutter'"
      [componentDefinition]="getComponentDefinitionObject()"
      [component]="getComponentObject()"
      [viewOnly]="true"
      [hideActionButtons]="true">
    </rappider-compiled-component-renderer>
  </div>

  <!-- Revert Button - Show for non-final steps -->
  <div class="revert-action" *ngIf="showRevertButton()">
    <rappider-button [type]="ButtonType.Default"
                     [text]="'Revert'"
                     [icon]="{
                       name: 'fa-solid fa-rotate-left',
                       type: IconType.FontAwesome
                     }"
                     [loading]="isReverting"
                     [disabled]="isReverting"
                     [tooltipText]="'Revert to this step and remove all subsequent messages'"
                     [popconfirmTitle]="'Discard all changes up to this commit? You can always undo this later.'"
                     [popconfirmOkText]="'Continue'"
                     [popconfirmCancelText]="'Cancel'"
                     [emitWithoutPopconfirm]="false"
                     (confirm)="onRevertConfirm()">
    </rappider-button>
  </div>

  <!-- Action Buttons -->
  <div class="save-actions" *ngIf="showSaveButtons()">
    <!-- Use this visual element Button -->
    <button class="action-button use-visual-element-button"
            [class.loading]="createEntityComponentLoading"
            [disabled]="isUseButtonDisabled()"
            [nz-tooltip]="getUseButtonTooltip()"
            (click)="onUseVisualElementClick()">
      <i class="fa-solid fa-plus button-icon"></i>
      <span class="button-text">{{ getUseButtonText() }}</span>
    </button>
  </div>

</div>
